import logo from '@/assets/logo/lyoc_invert.png';

const LyocTitleAbsolute = ({ showImg = false }) => {
	return (
		<div className="titler">
			<h3>Last Year of Carbon</h3>
			{showImg && <img src={logo} alt="Game Logo" />}
		</div>
	);
};

/*
    return(<div className='titleContainer'>
              <h2>Last Year</h2>
              <img src="src/assets/logo/lyoc_invert.png" alt="Game Logo" />
              <h2>of Carbon</h2>
            </div>
*/

export default LyocTitleAbsolute;
